import fetch from "isomorphic-fetch";
import { message, setIsFetching } from "../actions";
import Configuration from "../config";
import ReactGA from "react-ga";

/**
 * Nutzt die Api um die Rechnungsdaten einer Organisation für den aktuellen Monat zu exportieren
 *
 * @param a_formData {Object}
 * @param a_format {String}
 */
export function exportOrganizationBilling( a_formData, a_format = "xml" )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Rechnung",
				action: "Exportiere aktuelle Rechnung"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		headers["content-type"] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/organizations/${a_formData.organization_id}/billing?month=${a_formData.month}&year=${a_formData.year}&format=${a_format}&${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.blob().then( blob =>
						{
							let newBlob = new Blob( [ blob ], { type: "application/xml" } );
							const fileName = `Rechnung${a_formData.month}${a_formData.year}.xml`;
							
							if ( window.navigator.msSaveOrOpenBlob )
							{
								window.navigator.msSaveOrOpenBlob( newBlob, fileName );
							}
							else
							{
								let url = URL.createObjectURL( newBlob );
								let a = document.createElement( "a" );
								document.body.appendChild( a );
								a.style = "display: none";
								a.href = url;
								a.download = fileName;
								a.click();
								
								URL.revokeObjectURL( url );
							}
							dispatch( message( "Die Rechnung steht zum Download bereit.", "info", 5000 ) );
							dispatch( setIsFetching( false ) );
						} );
						
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( message( json.error, "error" ) );
									dispatch( setIsFetching( false ) );
								}
							);
					}
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function exportOrganizationBilling()

/**
 * Nutzt die Api um die Rechnungsdaten für alle Organisationen zu exportieren
 *
 * @param a_formData {Object}
 * @param a_format {String}
 */
export function exportOrganizationsBilling( a_formData, a_format = "xml" )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Rechnung",
				action: "Exportiere alle Rechnungen"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		headers["content-type"] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/organizations/billing/${a_formData.billing_year}/${a_formData.billing_month}?format=${a_format}&${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.blob().then( blob =>
						{
							let newBlob = new Blob( [ blob ], { type: `application/${a_format}` } );
							const fileName = `Rechnung${a_formData.billing_month}${a_formData.billing_year}.${a_format}`;
							
							if ( window.navigator.msSaveOrOpenBlob )
							{
								window.navigator.msSaveOrOpenBlob( newBlob, fileName );
							}
							else
							{
								let url = URL.createObjectURL( newBlob );
								let a = document.createElement( "a" );
								document.body.appendChild( a );
								a.style = "display: none";
								a.href = url;
								a.download = fileName;
								a.click();
								
								URL.revokeObjectURL( url );
							}
							dispatch( message( "Die Rechnungen stehen zum Download bereit.", "info", 5000 ) );
							dispatch( setIsFetching( false ) );
						} );
						
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
									dispatch( setIsFetching( false ) );
								}
							);
					}
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function exportOrganizationsBilling()

/**
 * Prüft ob die Domain existiert
 *
 * @param a_host {String}
 */
export function hostExists( a_host )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Domain",
				action: "Überprüfe Domain"
			} );
		}
		
		return fetch(
			`${Configuration.apiUrl}/exsists?host=${a_host}`,
			{
				credentials: "include",
				method: "GET"
			}
		)
			.then(
				response =>
				{
					if ( !response.ok )
					{
						dispatch( message( "Die Domain antwortet nicht. Bitte überprüfen Sie die Schreibweise.", "warning", 5000 ) );
						dispatch( setIsFetching( false ) );
						return false;
					}
					dispatch( setIsFetching( false ) );
					return true;
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
					return false;
				}
			);
	};
	
} // function hostExists()

